export type WolfMovementStateId = "exploration" | "longChase" | "sprint" | "exhausted";

export const WOLF_REALISM_CONFIG = {
  metersToPixels: 48,
  maxStamina: 100,
  sprintCooldownSeconds: 14,
  exhaustedSeconds: 1.65,
  sprintMinStamina: 34,

  states: {
    exploration: {
      id: "exploration",
      speedMps: 2.2,
      speedPx: 105.6,
      staminaDrainPerSecond: 0,
      staminaRecoveryPerSecond: 18,
      maxDurationSeconds: Number.POSITIVE_INFINITY,
      angularControl: 1,
      accelerationMultiplier: 0.55,
      decelerationMultiplier: 0.92,
      lateralSpeed: 0.9,
      velocitySmoothMultiplier: 0.78,
      rotationLerpMultiplier: 1.2,
      rotationMaxDegreesMultiplier: 0.78,
      animationFpsMultiplier: 0.65,
      worldSpeedMultiplier: 0.96
    },

    longChase: {
      id: "longChase",
      speedMps: 11.1,
      speedPx: 532.8,
      staminaDrainPerSecond: 0.35,
      staminaRecoveryPerSecond: 0,
      maxDurationSeconds: 120,
      angularControl: 0.72,
      accelerationMultiplier: 1,
      decelerationMultiplier: 1,
      lateralSpeed: 0.9,
      velocitySmoothMultiplier: 1,
      rotationLerpMultiplier: 1,
      rotationMaxDegreesMultiplier: 1,
      animationFpsMultiplier: 1,
      worldSpeedMultiplier: 1
    },

    sprint: {
      id: "sprint",
      minSpeedMps: 15.2,
      maxSpeedMps: 16.6,
      minSpeedPx: 729.6,
      maxSpeedPx: 796.8,
      staminaDrainPerSecond: 10,
      staminaRecoveryPerSecond: 0,
      maxDurationSeconds: 10,
      activationDistanceMinPx: 480,
      activationDistanceMaxPx: 720,
      angularControl: 0.42,
      accelerationMultiplier: 1.35,
      decelerationMultiplier: 1.18,
      lateralSpeed: 0.72,
      velocitySmoothMultiplier: 1.12,
      rotationLerpMultiplier: 0.65,
      rotationMaxDegreesMultiplier: 1.08,
      animationFpsMultiplier: 1.25,
      worldSpeedMultiplier: 1.05
    },

    exhausted: {
      id: "exhausted",
      speedMps: 8.2,
      speedPx: 393.6,
      staminaDrainPerSecond: 0,
      staminaRecoveryPerSecond: 22,
      maxDurationSeconds: 1.65,
      angularControl: 0.62,
      accelerationMultiplier: 0.7,
      decelerationMultiplier: 1.22,
      lateralSpeed: 0.76,
      velocitySmoothMultiplier: 0.86,
      rotationLerpMultiplier: 0.78,
      rotationMaxDegreesMultiplier: 0.74,
      animationFpsMultiplier: 0.82,
      worldSpeedMultiplier: 0.93
    }
  },

  recovery: {
    minRecoverySeconds: 30,
    recoverOnlyInExplorationOrIdle: true,
    lowThreatThreshold: 0.22
  },

  collider: {
    bodyLengthMeters: 1.5,
    bodyLengthPx: 72,
    bodyWidthRatio: 0.36,
    bodyHeightRatio: 0.32,
    ignoreTailCollision: true
  }
} as const;
